import React from 'react'
import {
  IconCar4,
  IconCarCheckmark,
  IconClockTimeArrow_1,
  IconDeleteDisabled_2,
  IconDocument4,
  IconDocumentContent12,
  IconDocumentContent19,
  IconDocumentContractEditPen,
  IconDocumentsFileCertificate1,
  IconDoneCheck,
  IconMissedCall,
  IconPhoneCall11,
} from '@creditas-ui/react'

const IconClockTimeArrow1 = IconClockTimeArrow_1
const IconDeleteDisabled2 = IconDeleteDisabled_2

const FEED_ITEM_TITLE = {
  REJECTED: {
    title: 'A proposta foi negada',
    icon: <IconDeleteDisabled2 strokeWidth={0.5} />,
  },
  REVIVAL: {
    title: 'A proposta foi reativada',
    icon: <IconCarCheckmark strokeWidth={0.5} />,
  },
  DOCUMENT_REQUIRED: {
    title: 'Documentos para análise está pendente',
    icon: <IconDocument4 strokeWidth={0.5} />,
  },
  DOCUMENTS_SENT: {
    title: 'Documentos enviados para análise',
    icon: <IconDocument4 strokeWidth={0.5} />,
  },
  INSPECTION_CREATED: {
    title: 'Vistoria do veículo iniciada',
    icon: <IconCar4 strokeWidth={0.5} />,
  },
  INSPECTION_RETRIED: {
    title: 'Vistoria nova do veículo iniciada',
    icon: <IconCar4 strokeWidth={0.5} />,
  },
  INSPECTION_FINALIZED: {
    title: 'Vistoria do veículo finalizada',
    icon: <IconCarCheckmark strokeWidth={0.5} />,
  },
  INSPECTION_REFUSED: {
    title: 'Vistoria do veículo recusada',
    icon: <IconDeleteDisabled2 strokeWidth={0.5} />,
  },
  PROPOSAL_QUALIFIED: {
    title: 'Proposta aprovada na pré-qualificação',
    icon: <IconDoneCheck strokeWidth={0.5} />,
  },
  CONTACT_ATTEMPT: {
    title: 'Tentativa de contato sem sucesso',
    subtitle: 'Tentaremos entrar em contato novamente',
    icon: <IconMissedCall strokeWidth={0.5} />,
  },
  CONTACT_SUCCESS: {
    title: 'Em negociação',
    subtitle:
      'Estamos em contato para tirar dúvidas e então seguir para as próximas etapas.',
    icon: <IconClockTimeArrow1 strokeWidth={0.5} />,
  },
  DOCUMENTS_PENDING: {
    title: 'Aguardando envio de documentos',
    subtitle:
      'Confira <a data-testid="link-assets-feed" href="https://assets.creditas.com/b2b-assets/1.0.0/Creditas-Partners-Guia-Documentos-Solicitacao-Credito.pdf" target="_blank">aqui</a> a lista completa dos documentos necessários para a análise de crédito.',
    icon: <IconDocument4 strokeWidth={0.5} />,
  },
  CREDIT_ANALYSIS_IN_PROGRESS: {
    title: 'Proposta em análise de crédito',
    subtitle:
      'O prazo para conclusão é de até 3 úteis, podendo ser alterado em caso de pendências de documentação. <br />Acompanhe o status com seu contato na Creditas.',
    icon: <IconClockTimeArrow1 strokeWidth={0.5} />,
  },
  CREDIT_ANALYSIS_APPROVED: {
    title: 'Proposta aprovada em crédito',
    subtitle:
      'Entraremos em contato para aprovar as condições comerciais. <br />A proposta pode ser alterada após a vistoria do imóvel.',
    icon: <IconDoneCheck strokeWidth={0.5} />,
  },
  INSPECTION_IN_PROGRESS: {
    title: 'Aguardando vistoria do imóvel',
    subtitle:
      'A avaliação do imóvel (laudo) será feita por uma empresa terceira.',
    icon: <IconClockTimeArrow1 strokeWidth={0.5} />,
  },
  LEGAL_ANALYSIS_IN_PROGRESS: {
    title: 'Proposta em análise jurídica',
    subtitle:
      'Confira <a href="https://assets.creditas.com/b2b-assets/1.0.0/Checklist-documentos-para-analise-juridica-Home-Equity.pdf" target="_blank">aqui</a> a lista completa dos documentos necessários para a análise jurídica. Você pode enviá-los por e-mail para seu contato na Creditas.',
    icon: <IconDocument4 strokeWidth={0.5} />,
  },
  CONTRACT_ISSUED: {
    title: 'Aguardando emissão do contrato',
    subtitle:
      'O contrato será enviado para avaliação do bancarizador e enviado para assinatura em até 24 horas.',
    icon: <IconDocumentContent19 strokeWidth={0.5} />,
  },
  CONTRACT_WAITING_TO_SIGN: {
    title: 'Aguardando assinatura',
    subtitle: 'Acompanhe com o cliente se existem eventuais dúvidas.',
    icon: <IconDocumentContractEditPen strokeWidth={0.5} />,
  },
  CONTRACT_SIGNED: {
    title: 'Contrato assinado',
    subtitle:
      'Agora, vamos enviá-lo ao cartório.<br /> O prazo médio é de 15-30 dias, mas pode variar no caso de pendências. Se necessário, entraremos em contato.',
    icon: <IconDocumentsFileCertificate1 strokeWidth={0.5} />,
  },
  CONTRACT_SENT: {
    title: 'Contrato enviado para assinatura',
    subtitle: 'Acompanhe com o cliente se existem eventuais dúvidas.',
    icon: <IconDocumentContractEditPen strokeWidth={0.5} />,
  },
  INSPECTION_APPROVED: {
    title: 'A vistoria do veículo foi aprovada',
    icon: <IconDoneCheck strokeWidth={0.5} />,
  },
  CREDIT_APPROVED: {
    title: 'Proposta aprovada em crédito',
    subtitle:
      'Entraremos em contato com o cliente para confirmar as condições comerciais. A proposta comercial pode ser alterada caso haja alterações na garantia ou que influenciem a capacidade de pagamento, como comprovação de renda do cliente, havendo assim uma nova análise de crédito',
    icon: <IconDoneCheck strokeWidth={0.5} />,
  },
  CONTACT_ATTEMPT_SUCCESS: {
    title: 'Contato com sucesso pelo',
    subtitle: 'Conseguimos falar com o cliente.',
    icon: <IconPhoneCall11 strokeWidth={0.5} />,
  },
  CONTACT_ATTEMPT_WITHOUT_SUCCESS: {
    title: 'Contato sem sucesso pelo',
    subtitle: 'Tentaremos falar com o cliente novamente.',
    icon: <IconMissedCall strokeWidth={0.5} />,
  },
  AUTO_CONTRACT_SIGNED: {
    title: 'Contrato assinado',
    subtitle:
      'Em média o desembolso na conta do cliente ocorrerá em até 2 dias úteis. Se necessário entraremos em contato.',
    icon: <IconDocumentContent12 strokeWidth={0.5} />,
  },
  DEFAULT_FEED_ANALYSIS: {
    title: 'Proposta criada',
    subtitle: 'Estamos analisando os dados informados',
    icon: <IconDoneCheck strokeWidth={0.5} />,
  },
}

export { FEED_ITEM_TITLE }
